<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-icon left>table_chart</v-icon>
        Reporte de Procesos por Despacho
      </v-card-title>

      <v-card-text>
        <v-row align="center">
          <v-col cols="12" sm="5">
            <v-select
              v-model="juzgadoSeleccionado"
              :items="opcionesJuzgados"
              item-text="nombre"
              item-value="id"
              label="Seleccione despacho (juzgado)"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-switch
              v-model="soloDescargar"
              label="Solo descargar (sin mostrar resultados)"
              color="primary"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="12" sm="4" class="text-right">
            <template v-if="!soloDescargar">
              <v-btn color="primary" @click="consultar" :loading="loading" class="mr-2">
                <v-icon left>search</v-icon>
                Consultar
              </v-btn>
            </template>
            <template v-if="soloDescargar || datos.length > 0">
              <v-btn color="success" @click="exportar('csv')" :loading="exportandoCsv" class="mr-2">
                <v-icon left>download</v-icon>
                CSV
              </v-btn>
              <v-btn color="green" dark @click="exportar('xlsx')" :loading="exportandoXlsx">
                <v-icon left>mdi-file-excel</v-icon>
                Excel
              </v-btn>
            </template>
          </v-col>
        </v-row>

        <v-alert v-if="consultado && datos.length === 0" type="info">
          Sin registros para el despacho seleccionado.
        </v-alert>

        <div v-if="datos.length > 0">
          <v-text-field
            v-model="busqueda"
            label="Buscar dentro de resultados"
            prepend-icon="search"
            single-line
            hide-details
            class="mb-4"
          ></v-text-field>

          <v-data-table
            :headers="headers"
            :items="datos"
            :search="busqueda"
            :items-per-page="15"
            class="elevation-1"
          >
            <template v-slot:item.demandante="{ item }">
              {{ item.demandante || 'N/A' }}
            </template>
            <template v-slot:item.demandado="{ item }">
              {{ item.demandado || 'N/A' }}
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ReporteDespacho',
  data() {
    return {
      juzgadoSeleccionado: null,
      juzgados: [],
      datos: [],
      busqueda: '',
      loading: false,
      soloDescargar: false,
      exportandoCsv: false,
      exportandoXlsx: false,
      consultado: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Radicado', value: 'radicado' },
        { text: 'Año', value: 'anio' },
        { text: 'Folios', value: 'folios' },
        { text: 'Cuadernos', value: 'cuadernos' },
        { text: 'Ubicación', value: 'ubicacion_sin' },
        { text: 'Caja', value: 'caja' },
        { text: 'Demandante', value: 'demandante' },
        { text: 'Doc. Demandante', value: 'documento_demandante' },
        { text: 'Demandado', value: 'demandado' },
        { text: 'Doc. Demandado', value: 'documento_demandado' },
        { text: 'Despacho', value: 'despacho' },
      ],
    };
  },
  created() {
    this.cargarJuzgados();
  },
  computed: {
    opcionesJuzgados() {
      return [{ id: 'all', nombre: 'TODOS' }, ...this.juzgados];
    },
  },
  methods: {
    cargarJuzgados() {
      axios
        .get('/api/listar_juzgados')
        .then((response) => {
          this.juzgados = response.data;
        })
        .catch((error) => {
          this.$alertify.error('Error al cargar juzgados');
        });
    },
    consultar() {
      this.loading = true;
      const params = {};
      if (this.juzgadoSeleccionado && this.juzgadoSeleccionado !== 'all') {
        params.juzgado_id = this.juzgadoSeleccionado;
      }
      axios
        .get('/api/reporte/despacho', { params })
        .then((response) => {
          this.datos = response.data.datos;
          this.consultado = true;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$alertify.error('Error al consultar el reporte');
        });
    },
    exportar(formato) {
      const params = {};
      if (this.juzgadoSeleccionado && this.juzgadoSeleccionado !== 'all') {
        params.juzgado_id = this.juzgadoSeleccionado;
      }

      if (formato === 'csv') {
        this.exportandoCsv = true;
      } else {
        this.exportandoXlsx = true;
      }

      const url = formato === 'csv'
        ? '/api/reporte/despacho/export'
        : '/api/reporte/despacho/export/xlsx';
      const mimeType = formato === 'csv'
        ? 'text/csv'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      axios
        .get(url, { params, responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: mimeType });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          const sufijo = this.juzgadoSeleccionado === 'all' || !this.juzgadoSeleccionado
            ? 'todos'
            : 'juzgado_' + this.juzgadoSeleccionado;
          link.download = `reporte_despacho_${sufijo}.${formato}`;
          link.click();
          this.exportandoCsv = false;
          this.exportandoXlsx = false;
        })
        .catch((error) => {
          this.exportandoCsv = false;
          this.exportandoXlsx = false;
          this.$alertify.error('Error al exportar');
        });
    },
  },
};
</script>
